export const qModEvent = details => {
    const event = new CustomEvent("QMODII", { detail: details });
    document.dispatchEvent(event);
};
